export default __webpack_public_path__ + "static/media/nextjs.404c70aa.svg";